$(document).on('click', '.menu-side .mobile-header', function(){
    $(this).parents('.menu-side').toggleClass('opened');
});